import SalesPersonPreview from "./SalesPersonPreview";

const PrintSalesPerson: React.FC = () => {
  return (
    <div className="inner-container">
      <SalesPersonPreview />
    </div>
  );
};

export default PrintSalesPerson;
